import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { StateChange } from 'ng-lazyload-image';
import { VgImageService } from './vg-image.service';

@Component({
    selector: 'vg-image',
    templateUrl: './vg-image.component.html',
    styleUrls: ['./vg-image.component.scss']
})
export class VgImageComponent implements OnInit {
    @Input() image: string;
    @Input() imgClass: string;
    @Input() placeholder: string = null;
    @Input() skeleton: boolean = true;
    @Input() alt: string = '';

    @Output('onStateChange') onStateChange: EventEmitter<StateChange> = new EventEmitter<StateChange>();

    @HostBinding('class') class: string;

    public loaded: boolean = false;
    protected cached: boolean = false;

    constructor(private vgImageService: VgImageService) {
        this.cached = this.vgImageService.has(this.image);
    }

    ngOnInit() {
        if (this.image == null) {
            this.image = this.placeholder;
        }

    }

    public onLazyLoadStateChange(event: StateChange): void {
        this.onStateChange.emit(event);

        switch (event.reason) {
            case 'observer-emit':
                this.loaded = (event?.data as any)?.isIntersecting;
            case 'loading-succeeded':
                this.loaded = true;
                this.vgImageService.set(this.image)
                break;
            case 'loading-failed':
                // TODO: sentry warning !!!
                this.loaded = false;
                break;
        }
    }
}
